import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Signup() {
  const [form, setForm] = useState({ orgName: '', firstName: '', lastName: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const update = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (form.password.length < 10) {
      setError('Password must be at least 10 characters with uppercase, lowercase, number, and special character');
      return;
    }
    setLoading(true);
    try {
      await signup(form.orgName, form.email, form.password, form.firstName, form.lastName);
      navigate('/');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' as const };
  const labelStyle = { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6, color: '#374151' };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ background: '#b91c1c', color: 'white', display: 'inline-block', padding: '12px 24px', borderRadius: 12, fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
            PPE Tracker
          </div>
          <p style={{ color: '#666', margin: 0 }}>Register your fire department</p>
        </div>

        <form onSubmit={handleSubmit} style={{ background: 'white', padding: 32, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h2 style={{ margin: '0 0 24px', fontSize: 20, fontWeight: 600 }}>Create Account</h2>

          {error && <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Department Name</label>
            <input value={form.orgName} onChange={update('orgName')} required style={inputStyle} placeholder="e.g. Springfield Fire Department" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
            <div>
              <label style={labelStyle}>First Name</label>
              <input value={form.firstName} onChange={update('firstName')} required style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Last Name</label>
              <input value={form.lastName} onChange={update('lastName')} required style={inputStyle} />
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Email</label>
            <input type="email" value={form.email} onChange={update('email')} required style={inputStyle} placeholder="you@department.com" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 }}>
            <div>
              <label style={labelStyle}>Password</label>
              <input type="password" value={form.password} onChange={update('password')} required style={inputStyle} placeholder="Min 10 characters" />
              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 3 }}>Upper, lower, number, special</div>
            </div>
            <div>
              <label style={labelStyle}>Confirm</label>
              <input type="password" value={form.confirmPassword} onChange={update('confirmPassword')} required style={inputStyle} />
            </div>
          </div>

          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', background: '#b91c1c', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Creating...' : 'Register Department'}
          </button>

          <p style={{ marginTop: 20, textAlign: 'center', fontSize: 14, color: '#666' }}>
            Already registered? <Link to="/login" style={{ color: '#b91c1c', fontWeight: 500 }}>Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
